import { Typography } from '@material-ui/core'
import { useStyles } from './styles'
const MediumText = (props) => {
  const { text } = props
  const classes = useStyles()
  return (
    <Typography variant="h5" classes={{ root: classes.root }}>
      {text}
    </Typography>
  )
}
export default MediumText
